// import external dependencies
import "lazysizes";

// Import everything from autoload
;
import Disclosure from "./components/Disclosure";

// Register Alpine components
document.addEventListener("alpine:init", () => {
  window.Alpine.data("Disclosure", Disclosure);
});



// WEBPACK FOOTER //
// ./scripts/main.js